export const basicMonthOptions = [...Array(16)].map((x, index) => ({ value: index, label: index }));

export const premiumMonthOptions = [...Array(16)].map((x, index) => ({ value: index, label: index }));
